import flex from "../../../styles/flex";


export default {
    wrapper: {
        ...flex.flexFill
    } as React.CSSProperties,
    wrapperAuto:{
        ...flex.flexAuto,
    } as React.CSSProperties,
    container: {
        ...flex.flexRows,
        height: "100%",
        alignItems: "center"
    } as React.CSSProperties,
    iconFlex: {
        ...flex.flexAuto,
    } as React.CSSProperties,
    icon: {
        fontSize: 24,
        marginRight: 30,
      
    } as React.CSSProperties,
    iconChevron: {
        fontSize: 24,

    } as React.CSSProperties,
    detailFlex: {
        ...flex.flexFill,
    },

}